import React, { useEffect, useRef, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import {createGuestUserInURL} from "../api/UrlUsers.api";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import videoMain from "../../media/videoMain.mp4";
import logo from "../../media/logo.png";

// --- START: Lógica del Formulario de Creación (Insertada) ---
interface User {
    active: boolean; 
    createdAt: string;
    customerId: string; 
    email: string;
    identifier: string; 
    name: string;
    notificationsType: string[]; 
    password: string; 
    permissions: string[]; 
    phoneNumber: string;
    role: "guest"
    surname: string;
    createdInURL: string
}

const defaultUser: User = {
    active: true, 
    createdAt: new Date().toISOString(),
    customerId: "", 
    email: "",
    identifier: "", 
    name: "",
    notificationsType: [], 
    password: "", 
    permissions: [], 
    phoneNumber: "",
    role: "guest", 
    surname: "",
    createdInURL: "guestUrl"
};
// --- END: Lógica del Formulario de Creación (Insertada) ---

// FUNCIÓN DE VALIDACIÓN DEL TELÉFONO 
const validatePhoneNumber = (phone: string): boolean => {
    // Expresión regular para el formato de teléfono (ej. +5491112345678 o 1112345678)
    // Permite un '+' opcional al inicio, seguido de 7 a 15 dígitos.
    const phoneRegex = /^\+?[0-9]{7,15}$/; 
    return phoneRegex.test(phone);
};
// ----------------------------------------------------


// FUNCIÓN DE VALIDACIÓN DE EMAIL
const validateEmail = (email: string): boolean => {
    // Expresión regular estándar y estricta para el formato de email
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
};
// ----------------------------------------------------


const GuestUserCreationForm: React.FC = () => {
  
  // --- Video Background States (Mantenidos) ---
  const videoRef = useRef<HTMLVideoElement>(null);
  const [fade, setFade] = useState(false);
  const [playAttempted, setPlayAttempted] = useState(false);
  


  // --URL
    const url = useParams();
    const customerIdFromUrl = url.customerId || ""; 
    
  
  //--Navigate
    const navigate = useNavigate();


  // --- Formulario de Creación States y Handlers (Insertados) ---
  const [user, setUser] = useState<User>({
      ...defaultUser,
      customerId: customerIdFromUrl, 
    });
  const [passwordConfirmation, setPasswordConfirmation] = useState("");
  
  const handleChangeField = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
    field: keyof User
  ) => {
    setUser((prev) => ({ ...prev, [field]: e.target.value }));
  };

 const handlePasswordConfirmationChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPasswordConfirmation(e.target.value);
  };

 
  
  const handleSubmit = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    // Validación de campos obligatorios
    if (!user.email || !user.name || !user.surname || !user.role) {
      toast.error("Nombre, apellido, email y rol son obligatorios.");
      return;
    }
    if (user.password !== passwordConfirmation) {
        toast.error("Las contraseñas no coinciden.");
        return;
    }

    if (!validatePhoneNumber(user.phoneNumber)) {
            toast.error("Por favor, ingrese un número de teléfono válido. Debe contener el código de área, solo dígitos, y opcionalmente puede incluir el '+' al inicio. Ejemplo: +5491112345678.");
            return;
        }
    
    if (!validateEmail(user.email)) {
        toast.error("Por favor, ingrese un formato de correo electrónico válido.");
        return;
    }
    
    try {
      console.log("Datos del usuario a crear:", user);
      const response = await createGuestUserInURL(user);
      //const response = await mokeado()
      toast.success(
        "Se ha creado el usuario correctamente, ya puede ingresar desde pro.lisual.com",
        {
          autoClose: 5000,
        }
      );
      setTimeout(() => {
        navigate("/login");
      }, 6000);
    
    } catch (error) {
            console.error(error);
            if (axios.isAxiosError(error) && error.response) {
                toast.error(error.response.data.error || "Error desconocido");
            } else {
                const err = error as Error;
                toast.error(err.message || "Error desconocido");
            }
      console.error("Error al crear el usuario:", error);
      
      return;
    } finally {
      setUser(defaultUser);
      setPasswordConfirmation("");
    }
    
    
  };  

 

  // --- Video Background Effect (Mantenido) ---
  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const handleEnded = () => {
      setFade(true);
      setTimeout(() => {
        video.currentTime = 0;
        video.play().catch(e => {
            console.warn("Fallo al intentar hacer loop del video:", e);
            setFade(false); 
        });
        setFade(false);
      }, 800);
    };

    video.addEventListener("ended", handleEnded);

    video.play().catch(e => {
        console.warn("Fallo en el autoPlay inicial:", e);
        setPlayAttempted(true);
    });

    return () => video.removeEventListener("ended", handleEnded);
  }, []);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.play().catch(() => {});
    }
  }, []);
  // ---------------------------------------------


  return (

    
    <section className="relative min-h-screen overflow-hidden">
      <video
        ref={videoRef}
        muted
        autoPlay
        playsInline
        className={`absolute top-0 left-0 w-full h-full object-cover`}
      >
        <source src={videoMain} type="video/mp4" />
      </video>

      <div
        className={`absolute inset-0 bg-black transition-opacity duration-700 ${
          fade ? "opacity-100" : "opacity-60"
        }`}
      ></div>

      <div className="container mx-auto py-20 relative z-10">
        <div className="flex flex-wrap items-center -mx-4 justify-between">
          
          {/* Columna de Texto Principal (REDUCIDA para dejar espacio) */}
          <div className="w-full md:w-6/12 lg:w-5/12 xl:w-5/12 text-left mb-10 lg:mb-0 px-4">
            <h1 className="text-5xl font-bold text-white mb-4">
              Plataforma de marketing y control N°1
            </h1>
            <p className="text-2xl text-white pl-[15px]">
              Obras de construcción y seguridad
            </p>
          </div>
          
          {/* Columna del Formulario (AUMENTADA para ocupar más espacio) */}
          <div className="w-full md:w-6/12 lg:w-7/12 xl:w-7/12 px-4"> 
            <div className="w-full mx-auto" data-aos="fade-up">
              
              {/* Contenedor del Formulario de Creación de Usuario */}
              <form className="relative block bg-white p-8 rounded-lg shadow-xl space-y-6 max-w-lg md:max-w-none">
                <div className="absolute top-0 right-0 p-4">
                    <img src={logo} width="80" height="80" alt="logo" className="rounded-full" />
                </div>
                <h3 className="text-2xl font-bold mb-6 text-center text-blue-600">Bienvenido a Lisual</h3>
                <h3 className="text-1xl font-bold mb-6 text-center text-blue-600">Ingresá tus datos para darte de alta como invitado</h3>

                {/* Campos de Información Personal (Ahora con 2 columnas para aprovechar el ancho) */}
                <div className="space-y-4">
                  <h4 className="text-lg font-semibold border-b pb-1 text-gray-700">Información Personal</h4>
                  
                  {/* Nombre y Apellido en 2 columnas */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Nombre*</label>
                      <input
                        type="text"
                        value={user.name}
                        onChange={(e) => handleChangeField(e, "name")}
                        className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-blue-500 focus:border-blue-500"
                        placeholder="Nombre"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Apellido*</label>
                      <input
                        type="text"
                        value={user.surname}
                        onChange={(e) => handleChangeField(e, "surname")}
                        className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-blue-500 focus:border-blue-500"
                        placeholder="Apellido"
                      />
                    </div>
                  </div>

                  {/* Email y Teléfono en 2 columnas */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Email*</label>
                      <input
                        type="email"
                        value={user.email}
                        onChange={(e) => handleChangeField(e, "email")}
                        className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-blue-500 focus:border-blue-500"
                        placeholder="ejemplo@dominio.com"
                      />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Teléfono*</label>
                        <input
                            type="tel"
                            value={user.phoneNumber}
                            // ----------------------------------------------------
                            // 2. LÓGICA DE MANEJO DEL INPUT (COPIADA)
                            // ----------------------------------------------------
                            onChange={(e) => {
                                const value = e.target.value.trim();
                                // Limpiamos el valor de espacios, guiones y paréntesis, pero mantenemos un '+' inicial
                                const cleanedValue = value.replace(/[\s\-\(\)]/g, ''); 
                                
                                // Aseguramos que solo haya un '+' al inicio, si existe.
                                let finalValue = cleanedValue;
                                if (cleanedValue.startsWith('+')) {
                                  // Mantenemos el '+' inicial y luego removemos cualquier otro '+' del resto de la cadena.
                                  finalValue = '+' + cleanedValue.substring(1).replace(/\+/g, '');
                                } else {
                                  // Si no empieza por '+', nos aseguramos de que no haya ninguno.
                                   finalValue = cleanedValue.replace(/\+/g, '');
                                }
                                
                                // Finalmente, solo permitimos dígitos después del posible '+' inicial.
                                finalValue = finalValue.replace(/[^\d+]/g, ''); // Remueve todo lo que no sea dígito o '+'
                                
                                setUser((prev) => ({ ...prev, phoneNumber: finalValue }));
                            }}
                            // ----------------------------------------------------
                            className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-blue-500 focus:border-blue-500"
                            placeholder="Ej: +5491112345678" // Se recomienda usar el placeholder original para guiar.
                        />
                    </div>
                  </div>

                  </div>
                  

                {/* Campos de Seguridad (Contraseñas) - También en 2 columnas */}
                <div className="space-y-4 pt-4 border-t">
                  <h4 className="text-lg font-semibold border-b pb-1 text-gray-700">Seguridad</h4>
                  
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {/* Contraseña */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Contraseña</label>
                      <input
                        type="password"
                        value={user.password}
                        onChange={(e) => handleChangeField(e, 'password')}
                        className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-blue-500 focus:border-blue-500"
                        placeholder="*********"
                      />
                    </div>

                    {/* Confirmar Contraseña */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Confirmar Contraseña*</label>
                      <input
                        type="password"
                        value={passwordConfirmation}
                        onChange={handlePasswordConfirmationChange} 
                        className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-blue-500 focus:border-blue-500"
                        placeholder="*********"
                      />
                      {/* Lógica de validación en tiempo real */}
                      {passwordConfirmation && user.password && user.password !== passwordConfirmation && (
                        <p className="text-red-500 text-xs mt-1">⚠️ Las contraseñas no coinciden.</p>
                      )}
                    </div>
                  </div>
                </div>

                {/* Botón de Submit (Crear Usuario) */}
                <div className="text-center pt-4">
                  <button
                    className="w-full bg-green-500 text-white font-bold py-3 px-4 rounded-lg hover:bg-green-600 transition duration-300"
                    type="submit"
                    onClick={handleSubmit}
                  >
                    Crear Usuario
                  </button>
                </div>
                
                
                
              </form>

              <ToastContainer />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GuestUserCreationForm;